module.exports = __webpack_public_path__ + "media/images/gallery/vis-d167b56978e261f9b2a4f7d8a0c24a5e.png";